import { initComponent } from './core/init-component.js'

initComponent('.js-exclusive-benefits', snippet => {
  const triggers = snippet.querySelectorAll('.js-benefit-trigger')
  const drawer = document.getElementById('pdp__exclusive-benefit-drawer')
  const overlay = document.getElementById('pdp__exclusive-benefit-overlay')

  if (!triggers || !drawer || !overlay) return {}

  const drawerHeading = drawer.querySelector('.js-drawer-heading')
  const drawerDescription = drawer.querySelector('.js-drawer-description')
  const drawerBanner = drawer.querySelector('.js-drawer-banner')
  const drawerContainer = drawer.querySelector('.pdp__exclusive-benefit--container')
  const closeBtn = drawer.querySelector('.js-benefits-drawer-close')
  let lockedScrollY = 0

  const openDrawer = () => {
    lockedScrollY = window.scrollY
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${lockedScrollY}px`
    document.body.style.width = '100%'
    requestAnimationFrame(() => {
      drawer.classList.add('is-open')
      overlay.classList.add('is-open')
    })
  }

  const closeDrawer = () => {
    const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10)) || lockedScrollY
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    window.scrollTo({left:0, top:scrollY, behavior: 'instant'})
    drawerContainer?.scrollTo({ top: 0, behavior: "instant" })
    drawer.scrollTo({ top: 0, behavior: 'instant' })
    drawer.classList.remove('is-open')
    overlay.classList.remove('is-open')
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const heading = trigger.dataset.benefitHeading
      const description = trigger.dataset.benefitDescription
      const imageUrl = trigger.dataset.benefitDrawerImage
      const imageAlt = trigger.dataset.benefitDrawerImageAlt

      drawerHeading.textContent = heading
      const processedDescription = description.replace(/<p>\s*<\/p>/g, '<br>')
      drawerDescription.innerHTML = processedDescription

      if (imageUrl && imageUrl !== '') {
        const img = new Image()
        img.alt = imageAlt
        img.onload = () => {
          drawerBanner.innerHTML = ''
          drawerBanner.appendChild(img)
          drawerBanner.style.display = 'block'
          openDrawer()
        }
        img.onerror = () => {
          drawerBanner.style.display = 'none'
          openDrawer()
        }
        img.src = imageUrl
      } else {
        drawerBanner.style.display = 'none'
        openDrawer()
      }

    })
  })

  closeBtn.addEventListener('click', closeDrawer)
  overlay.addEventListener('click', closeDrawer)

  return {
    unload() {
      triggers.forEach(trigger => trigger.replaceWith(trigger.cloneNode(true)))
    }
  }
})
